/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class PreventiveSheetAttachmentService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'PreventiveSheetAttachmentService\' loaded');
    }
}

export { PreventiveSheetAttachmentService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/service/PreventiveSheetAttachmentService.js